export { EloWarningOctagonIcon } from './warning-icon-octagon'
